import React from 'react';
import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';

export const articles = [
  {
    id: 'ai-financial-services',
    category: 'Report',
    title: 'The Future of AI in Financial Services: 2025 Outlook',
    image: 'https://images.unsplash.com/photo-1620714223084-8fcacc6dfd8d?auto=format&fit=crop&q=80&w=800',
    date: 'Oct 12, 2023',
    excerpt: 'How generative AI is reshaping risk assessment and personalized banking experiences.'
  },
  {
    id: 'supply-chain-geopolitics',
    category: 'Article',
    title: 'Navigating Geopolitical Shifts in Global Supply Chains',
    image: 'https://images.unsplash.com/photo-1578575437130-527eed3abbec?auto=format&fit=crop&q=80&w=800',
    date: 'Oct 08, 2023',
    excerpt: 'Building resilience in a fragmented world through strategic nearshoring and diversification.'
  },
  {
    id: 'esg-value-creation',
    category: 'Perspective',
    title: 'Beyond Compliance: ESG as a Value Creator',
    image: 'https://images.unsplash.com/photo-1464938050520-ef2270bb8ce8?auto=format&fit=crop&q=80&w=800',
    date: 'Sep 29, 2023',
    excerpt: 'Why sustainable practices are no longer a cost center, but a primary driver of long-term ROI.'
  }
];

export default function Insights() {
  return (
    <section id="insights" className="py-24 bg-slate-50">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="text-center max-w-2xl mx-auto mb-16">
          <h2 className="text-amber-600 font-semibold tracking-wider uppercase text-sm mb-3">Featured Insights</h2>
          <h3 className="text-4xl font-serif text-slate-900 mb-6">Latest perspectives from our partners.</h3>
        </div>

        <div className="grid md:grid-cols-3 gap-8">
          {articles.map((article, index) => (
            <motion.div 
              key={article.id}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ delay: index * 0.1 }}
              className="group bg-white flex flex-col h-full overflow-hidden hover:shadow-xl transition-shadow duration-300"
            >
              <Link to={`/insights/${article.id}`} onClick={() => window.scrollTo(0, 0)}>
                <div className="relative h-48 overflow-hidden">
                  <img src={article.image} alt={article.title} className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-700" />
                  <div className="absolute top-4 left-4 bg-slate-900 text-white text-xs font-semibold px-3 py-1 uppercase tracking-wider">
                    {article.category}
                  </div>
                </div>
                <div className="p-6 flex flex-col flex-grow border border-t-0 border-slate-100">
                  <div className="text-sm text-slate-500 mb-3">{article.date}</div>
                  <h4 className="text-xl font-serif font-bold text-slate-900 mb-4 group-hover:text-amber-600 transition-colors">
                    {article.title}
                  </h4>
                  <div className="mt-auto flex items-center text-sm font-semibold text-slate-900 group-hover:text-amber-600 transition-colors">
                    Read More 
                    <SafeIcon icon={FiIcons.FiArrowRight} className="ml-2 w-4 h-4 transition-transform group-hover:translate-x-1" />
                  </div>
                </div>
              </Link>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}